import React from 'react';
import PropTypes from 'prop-types';
import { withI18n } from 'spa/Components/Context';

import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';
import Divider from '@urbanmassage/component-library/lib/Divider/Divider';

import './gift-card.less';

const GiftCard = ({
  deliveryOption,
  deliveryPrice,
  showSummary = false,
  sticky = false,
  totalPrice,
  voucherPrice,
  giftUpgrade,
  formatedUpgradePrice,
}, { i18n }) => (
  <div className={`gift-card__card ${sticky ? 'gift-card__card-sticky' : ''}`} data-testid="gift-card">
    <div className="gift-card__card-title-wrapper">
      <div className="gift-card__card-title-wrapper-inner">
        <Typography variant={TypeVariants.bodyLarge} className="gift-card__card-title" data-testid="gift-card-title">
          {i18n._x('Your voucher', 'Gift Card title')}
        </Typography>
        <Typography variant={TypeVariants.h2} className="gift-card__card-subtitle" data-testid="gift-card-subtitle">
          {totalPrice}
        </Typography>
      </div>
    </div>
    {showSummary && (
      <div className="gift-card__card-summary" data-testid="gift-card-summary">
        <Typography variant={TypeVariants.bodyLarge} className="gift-card__card-summary-title" bold data-testid="gift-card-summary-title">
          {i18n._x('Payment summary', 'Gift Card title')}
        </Typography>
        <div>
          <div className="gift-card__card-summary-line">
            <Typography variant={TypeVariants.body} className="gift-card__card-summary-delivery" data-testid="gift-card-voucher">
              {deliveryOption === 'e-voucher' ? i18n._x('Email voucher', 'Gift Card delivery') : i18n._x('Postal voucher', 'Gift Card delivery')}
            </Typography>
            <Typography variant={TypeVariants.body} className="gift-card__card-summary-delivery-price" data-testid="gift-card-voucher-price">
              {voucherPrice}
            </Typography>
          </div>
          {giftUpgrade && giftUpgrade !== 0 && (
            <div className="gift-card__card-summary-line">
              <Typography variant={TypeVariants.body} className="gift-card__card-summary-delivery" data-testid="gift-card-voucher">
                {giftUpgrade.description}
              </Typography>
              <Typography variant={TypeVariants.body} className="gift-card__card-summary-delivery-price" data-testid="gift-card-voucher-price">
                {formatedUpgradePrice}
              </Typography>
            </div>
          )}
          <div className="gift-card__card-summary-line">
            <Typography variant={TypeVariants.body} className="gift-card__card-summary-postage" data-testid="gift-card-delivery-option">
              {i18n._x('Delivery', 'Gift Card delivery')}
            </Typography>
            <Typography variant={TypeVariants.body} className="gift-card__card-summary-postage-price" data-testid="gift-card-delivery-option-price">
              {deliveryPrice}
            </Typography>
          </div>
          <Divider />
          <div className="gift-card__card-summary-line gift-card__card-summary-line-total">
            <Typography variant={TypeVariants.body} bold className="gift-card__card-summary-total" data-testid="gift-card-total-title">
              {i18n._x('Total to pay', 'Gift Card total')}
            </Typography>
            <Typography variant={TypeVariants.body} bold className="gift-card__card-summary-total-price" data-testid="gift-card-total-price">
              {totalPrice}
            </Typography>
          </div>
        </div>
      </div>
    )}
  </div>
);

GiftCard.propTypes = {
  formatedUpgradePrice: PropTypes.string,
  giftUpgrade: PropTypes.shape({
    description: PropTypes.string,
    isPopular: PropTypes.bool,
    option_id: PropTypes.string,
    upgrade_value: PropTypes.string,
  }),
  deliveryOption: PropTypes.string,
  deliveryPrice: PropTypes.string,
  showSummary: PropTypes.bool,
  sticky: PropTypes.bool,
  totalPrice: PropTypes.string.isRequired,
  voucherPrice: PropTypes.string,
};

export default withI18n(GiftCard);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCard.jsx